import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Button
} from 'reactstrap';

const Header = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <div>
            <Navbar className="px-4" expand="md" dark style={{ backgroundColor: 'var(--primary-color)' }}>
                <NavbarBrand className="" href="/"><span className="font-weight-bold">Falendi </span>Platform</NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="mr-auto" navbar>

                    </Nav>
                    <Link to="/login">
                        <Button color="primary">Login</Button>
                    </Link>
                </Collapse>
            </Navbar>
        </div>
    );
}

export default Header;